/* tslint:disable */
/* eslint-disable */
/**
 * GateHouse AIS REST interface
 * AIS system for monitoring vessel traffic. Commercial WebService. Contact GateHouse support for more information.
 *
 * The version of the OpenAPI document: 0.2.2
 * Contact: support@gatehouse.dk
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { PortHistorical } from './PortHistorical';
import {
    PortHistoricalFromJSON,
    PortHistoricalFromJSONTyped,
    PortHistoricalToJSON,
} from './PortHistorical';

/**
 * 
 * @export
 * @interface ShipHistoricalPortPost200Response
 */
export interface ShipHistoricalPortPost200Response {
    /**
     * 
     * @type {Array<PortHistorical>}
     * @memberof ShipHistoricalPortPost200Response
     */
    records: Array<PortHistorical>;
}

/**
 * Check if a given object implements the ShipHistoricalPortPost200Response interface.
 */
export function instanceOfShipHistoricalPortPost200Response(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "records" in value;

    return isInstance;
}

export function ShipHistoricalPortPost200ResponseFromJSON(json: any): ShipHistoricalPortPost200Response {
    return ShipHistoricalPortPost200ResponseFromJSONTyped(json, false);
}

export function ShipHistoricalPortPost200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ShipHistoricalPortPost200Response {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'records': ((json['records'] as Array<any>).map(PortHistoricalFromJSON)),
    };
}

export function ShipHistoricalPortPost200ResponseToJSON(value?: ShipHistoricalPortPost200Response | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'records': ((value.records as Array<any>).map(PortHistoricalToJSON)),
    };
}

